import React from 'react';
import { invert } from './utils';
import { SecondaryLine } from './Lines';
import MathBoxGroup from './MathBoxGroup';

const TotalDiscountGroup = ({ pricing, isUnitedStates }) => {
  const { totalDiscount, isSeeDealer, totalEmployeeDiscount } = pricing;

  if (isSeeDealer || !totalDiscount) {
    return null;
  }

  return (
    <MathBoxGroup>
      <SecondaryLine
        labelKey="total.discounts"
        value={invert(
          totalEmployeeDiscount && isUnitedStates
            ? totalEmployeeDiscount
            : totalDiscount
        )}
      />
    </MathBoxGroup>
  );
};

export default TotalDiscountGroup;
